<template>
    <div class="table-responsive">
        <table class="table" style="table-layout: fixed">
           <thead>
               <tr>
                   <th style="width: 220px">Activiteit</th>
                   <th style="width: 220px">Agenda</th>
                   <th v-for="day in days" :key="`day-${day.index}`" style="width: 120px">
                       {{ day.name }}
                   </th>
               </tr>
           </thead>
            <tbody>
                <template v-for="activity in activities" :key="activity.id">
                    <tr
                        v-for="(agenda, index) in activity.agendas"
                        :key="agenda.id"
                    >
                        <td
                            v-if="index < 1"
                            :rowspan="activity?.agendas?.length"
                            style="font-size: 14px;"
                        >
                            {{ activity.title }}
                        </td>
                        <td>
                            <div class="d-flex justify-content-between">
                                <div style="font-size: 14px">
                                    {{ agenda.description }}
                                </div>

                                <div>
                                    <AgendaModal
                                        :agenda="agenda"
                                        @on-update="$emit('on-update')"
                                    />


                                    <AgendaRemoveModal
                                        :agenda="agenda"
                                        @on-update="$emit('on-update')"
                                        v-if="activity.agendas.length > 1"
                                    />
                                </div>
                            </div>
                        </td>
                        <td v-for="day in days" :key="`day-${day.index}`">
                            <div style="height: 100%; max-height: 140px; overflow: auto" class="edit-col">
                                <SlotEditForm
                                    v-for="slot in getSlotsByDay(agenda, day.index)"
                                    :key="slot.id"
                                    :time-slot="slot"
                                    @on-update="$emit('on-update')"
                                />
                            </div>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
    </div>
</template>

<script>
import _ from "lodash";

export default {
    name: "MaisonAgendas",
    props: {
        maison: {
            type: Object,
        },
        activities: {
            type: Array,
        },
    },
    data() {
        return {
            days: [
                { index: 1, name: "Ma" },
                { index: 2, name: "Di" },
                { index: 3, name: "Wo" },
                { index: 4, name: "Do" },
                { index: 5, name: "Vr" },
                { index: 6, name: "Za" },
                { index: 0, name: "Zo" },
            ],
        };
    },
    methods: {
        getSlotsByDay(agenda, index) {
            return _.filter(
                agenda.slots,
                (slot) => slot.day === index && slot.is_disabled == 0
            );
        },
    },
};
</script>

<style scoped>
.edit-col::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
}

.edit-col::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, .5);
    box-shadow: 0 0 1px rgba(255, 255, 255, .5);
}
</style>
